export default __webpack_public_path__ + "static/feature8-2ced7be79860e7a576acebe998461a31.webp";